import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { productSevice } from "./productService";

export const getAllProducts = createAsyncThunk(
  "product/get",
  async (data, thunkAPI) => {
    try { return await productSevice.getProducts(data); }
    catch (error) { return thunkAPI.rejectWithValue(error); }
  }
);

export const getAProduct = createAsyncThunk(
  "product/getAProduct",
  async (id, thunkAPI) => {
    try { return await productSevice.getSingleProduct(id); }
    catch (error) { return thunkAPI.rejectWithValue(error); }
  }
);

export const addToWishlist = createAsyncThunk(
  "product/wishlist",
  async (prodId, thunkAPI) => {
    try { return await productSevice.addToWishlist(prodId); }
    catch (error) { return thunkAPI.rejectWithValue(error); }
  }
);

export const addRating = createAsyncThunk(
  "product/rating",
  async (data, thunkAPI) => {
    try { return await productSevice.rateProduct(data); }
    catch (error) { return thunkAPI.rejectWithValue(error); }
  }
);

export const getCategoryTree = createAsyncThunk(
  "product/getCategoryTree",
  async (_, thunkAPI) => {
    try { return await productSevice.getCategoryTree(); }
    catch (error) { return thunkAPI.rejectWithValue(error); }
  }
);

const productState = {
  product: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  categoryTree: [],
};

export const productSlice = createSlice({
  name: "product",
  initialState: productState,
  reducers: {
    resetSingleProduct: (state) => { state.singleproduct = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => { state.isLoading = true; })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.isLoading = false; state.isError = false; state.isSuccess = true;
        state.product = action.payload;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.isError = true; state.isLoading = false; state.isSuccess = false; state.message = action.error;
      })
      .addCase(addToWishlist.pending, (state) => { /* silent — no full-screen loader */ })
      .addCase(addToWishlist.fulfilled, (state, action) => {
        state.isLoading = false; state.isError = false; state.isSuccess = true;
        state.addToWishlist = action.payload;
        state.message = "Product Added to Wishlist!";
      })
      .addCase(addToWishlist.rejected, (state, action) => {
        state.isLoading = false; state.isError = true; state.isSuccess = false; state.message = action.error;
      })
      .addCase(getAProduct.pending, (state) => { state.isLoading = true; })
      .addCase(getAProduct.fulfilled, (state, action) => {
        state.isLoading = false; state.isError = false; state.isSuccess = true;
        state.singleproduct = action.payload;
        state.message = "Product Fetched Successfully";
      })
      .addCase(getAProduct.rejected, (state, action) => {
        state.isError = true; state.isLoading = false; state.isSuccess = false; state.message = action.error;
      })
      .addCase(addRating.pending, (state) => { state.isLoading = true; })
      .addCase(addRating.fulfilled, (state, action) => {
        state.isLoading = false; state.isError = false; state.isSuccess = true;
        state.rating = action.payload; state.message = "Rating Added Successfully";
        if (state.isSuccess) toast.success("Rating Added Successfully");
      })
      .addCase(addRating.rejected, (state, action) => {
        state.isError = true; state.isLoading = false; state.isSuccess = false; state.message = action.error;
      })
      .addCase(getCategoryTree.pending, (state) => { state.isLoading = false; })
      .addCase(getCategoryTree.fulfilled, (state, action) => {
        state.categoryTree = action.payload;
      })
      .addCase(getCategoryTree.rejected, (state) => { state.categoryTree = []; });
  },
});

export default productSlice.reducer;
export const { resetSingleProduct } = productSlice.actions;
